import React, { FC } from "react";

import { Divider, DividerProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ColorGray } from "./theme";

const StyledDivider = styled(Divider)(({ theme }) => ({
  color: ColorGray.light,
}));

type Size = "xs" | "s" | "m" | "l";

export interface IgDiverProps extends DividerProps {
  spacing?: Size;
}

type Spacing = Record<Size, string>;

const Spacing: Spacing = {
  xs: "5px",
  s: "10px",
  m: "15px",
  l: "20px",
};

/**
 * @see Divider
 */
export const IgDivider: FC<IgDiverProps> = (props) => {
  const { sx, spacing, ...rest } = props;

  if (spacing) {
    return (
      <StyledDivider
        sx={{
          marginTop: Spacing[spacing],
          marginBottom: Spacing[spacing],
          ...sx,
        }}
        {...rest}
      />
    );
  }
  return <StyledDivider {...rest} />;
};
